import { Navigate } from 'react-router-dom'

function GameHomeRoute() {
  return <Navigate replace to="/summary/" />
}

export default GameHomeRoute
